<template>
  <li class="border-b border-b-border tablet:border-b-0">
    <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events vuejs-accessibility/no-static-element-interactions -->
    <div @click.capture="onClick">
      <ZtLink
        :to="url"
        class="main-link flex items-center justify-between gap-2 py-3 text-size-5 font-bold text-scheme-invert tablet:block tablet:py-0 tablet:text-size-6 tablet:text-primary tablet:hover:text-primary-light desktop:text-size-5"
        :data-track-id="id"
        :class="{
          '!text-primary': isOpen,
        }"
      >
        <span>{{ label }}</span>
        <IconArrowToggle
          :open="isOpen"
          class="size-[0.8em] text-muted transition duration-200 ease-bounce tablet:hidden"
        />

        <SpriteSymbol
          name="chevron-right"
          class="hidden size-[0.7em] tablet:ml-1 tablet:inline-block"
        />
      </ZtLink>
    </div>

    <VuepalTransitionHeight
      opacity
      :easing-enter="EASE_SWING"
      :easing-leave="EASE_SWING"
      :duration="200"
    >
      <div v-show="isOpen" v-if="children" class="tablet:!block">
        <ul
          class="main-links-wrapper grid gap-2 pb-4 tablet:mt-2 tablet:gap-1 desktop:gap-2"
        >
          <li v-for="(child, childIndex) in children" :key="childIndex">
            <ZtLink
              :to="child.url"
              :data-track-id="child.id"
              class="block text-size-5 hover:text-primary tablet:text-size-6"
              >{{ child.label }}</ZtLink
            >
          </li>

          <li class="tablet:hidden">
            <ZtLink :to="url" class="link text-size-5">
              <span>{{ $texts('menu.secondLevelOverview', 'Overview') }}</span>
            </ZtLink>
          </li>
        </ul>
      </div>
    </VuepalTransitionHeight>
  </li>
</template>

<script setup lang="ts">
import { EASE_SWING } from '../../../../../settings/tailwind'
import type { MappedLink } from '../helper'

const props = defineProps<MappedLink>()

const active = defineModel<string>()
const { isMobile } = useViewport()

const isOpen = computed(() => active.value === props.id)

const { $texts } = useEasyTexts()

function onClick(e: MouseEvent) {
  // On desktop the click should trigger the link click.
  if (!isMobile.value) {
    return
  }

  // On mobile, prevent the default behaviour and instead open the subtree menu.
  e.preventDefault()
  e.stopPropagation()
  active.value = isOpen.value ? '' : props.id
}
</script>
